import { isStreamIQ, isToya } from '../lib'
import { IVODServiceStreamIQ } from '@/shared/types/services/types/vodService/IVodServiceStreamIQ'

export const getVodService = async () => {
    if (isStreamIQ()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/streamiq/services/containers/VODService/VODServiceStreamIQ')
            return module.default as IVODServiceStreamIQ
        } catch (error) {
            console.warn('VODServiceStreamIQ module is missing.', error)
            return null
        }
    }
    if (isToya()) {
        try {
            const module =
                await require('@/clients/toya/services/containers/VODServices/VODServiceCODESPOT')
            return module.default
        } catch (error) {
            console.warn('VODServiceCODESPOT module is missing.', error)
            return null
        }
    }

    throw new Error('Unknown API type')
}
